/**
 * Version these identifiers together when a web auth rollout must require a
 * fresh browser login without revoking Firebase users or mobile sessions.
 */
const WEB_AUTH_ROLLOUT_VERSION = "v2";

export const WEB_SESSION_COOKIE_NAME = `__session_${WEB_AUTH_ROLLOUT_VERSION}`;
export const WEB_FIREBASE_APP_NAME = `butter-web-${WEB_AUTH_ROLLOUT_VERSION}`;
